import { TeamFlag } from './team-flag';

type SortColumn = 'points' | 'pointsPercentage' | 'appearances' | 'name';

interface StatsTableHeaderProps {
  sortBy: SortColumn;
  sortOrder: 'asc' | 'desc';
  onSort: (column: SortColumn) => void;
}

export function StatsTableHeader({ sortBy, sortOrder, onSort }: StatsTableHeaderProps) {
  const getSortIcon = (column: SortColumn) => {
    if (sortBy !== column) return '';
    return sortOrder === 'asc' ? ' ▲' : ' ▼';
  };

  return (
    <thead>
      <tr>
        <th style={{ width: '50px' }}>#</th>
        <th onClick={() => onSort('name')} style={{ cursor: 'pointer' }}>
          Player{getSortIcon('name')}
        </th>
        <th onClick={() => onSort('appearances')} style={{ cursor: 'pointer', textAlign: 'center' }}>
          Appearances{getSortIcon('appearances')}
        </th>
        <th onClick={() => onSort('points')} style={{ cursor: 'pointer', textAlign: 'center' }}>
          Points{getSortIcon('points')}
        </th>
        <th onClick={() => onSort('pointsPercentage')} style={{ cursor: 'pointer', textAlign: 'center' }}>
          Points %{getSortIcon('pointsPercentage')}
        </th>
        <th style={{ textAlign: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
            <TeamFlag team="USA" /> USA
          </div>
        </th>
        <th style={{ textAlign: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
            <TeamFlag team="EU" /> Europe
          </div>
        </th>
      </tr>
    </thead>
  );
}
